import { LineShareButton, LineIcon } from "react-share";
import React from "react";

var LineShare = function LineShare(_ref) {
  var url = _ref.url,
      title = _ref.title,
      onSocialButtonClicked = _ref.onSocialButtonClicked,
      socialType = _ref.socialType;
  return /*#__PURE__*/React.createElement(LineShareButton, {
    url: url,
    quote: title,
    onClick: function onClick() {
      return onSocialButtonClicked("".concat(socialType || 'button', " clicked."));
    }
  }, /*#__PURE__*/React.createElement(LineIcon, {
    size: 40,
    round: true
  }));
};

export default LineShare;